package com.patronat.top.client.presentation.auth

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.core.utils.UiText
import com.patronat.top.dto.AuthFlow
import com.patronat.top.dto.UserRole

data class ClientAuthViewState(
    val step: ClientAuthStep = ClientAuthStep.GetStarted,
    val flow: AuthFlow = AuthFlow.REGISTRATION,
    val isLoading: Boolean = false,
    val firstName: String = "",
    val lastName: String = "",
    val phone: String = "",
    val email: String = "",
    val firstNameError: UiText? = null,
    val lastNameError: UiText? = null,
    val phoneError: UiText? = null,
    val emailError: UiText? = null,
    val otpError: UiText? = null,
    val isOtpSent: Boolean = false,
    val otpTimerKey: Int = 0,
    val showSuccessSheet: Boolean = false
) : ViewState

enum class ClientAuthStep {
    GetStarted,
    RegistrationForm,
    LoginForm,
    VerifyPhone
}

sealed interface ClientAuthEvent : ViewEvent {
    data object OnRegisterByPhoneClicked : ClientAuthEvent
    data object OnLoginByPhoneClicked : ClientAuthEvent
    data object OnContinueWithoutAccountClicked : ClientAuthEvent
    data object OnBackClicked : ClientAuthEvent
    data class OnFirstNameChanged(val value: String) : ClientAuthEvent
    data class OnLastNameChanged(val value: String) : ClientAuthEvent
    data class OnPhoneChanged(val value: String) : ClientAuthEvent
    data class OnEmailChanged(val value: String) : ClientAuthEvent
    data object OnSubmitRegistration : ClientAuthEvent
    data object OnSubmitLogin : ClientAuthEvent
    data class OnSubmitPhoneCode(val code: String) : ClientAuthEvent
    data object OnResendPhoneCode : ClientAuthEvent
    data object OnSuccessPrimaryClicked : ClientAuthEvent
    data object OnDismissSuccess : ClientAuthEvent
}

sealed interface ClientAuthEffect : ViewSideEffect {
    data object ContinueWithoutAccount : ClientAuthEffect
    data class NavigateToHome(val role: UserRole) : ClientAuthEffect
}
